module.exports = "img/flags/MZ.1ba782c.png";